define('views/components/customer/customer',['require','backbone','text!templates/components/customer/customer.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/customer/customer.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'customer-item',

        templateHelpers: function () {
            var _this = this;
            var status = App.context.constants.reseller_statuses.find(function (statusObject) {
                return _this.model.attributes.status == statusObject.key;
            });
            return {
                statusText: status.name
            };
        },
    });
});
